<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] flex flex-col">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Recolha</h3>
            <AppButton class=" self-end text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="close" :width=23 :height=23 /> 
        </div>

        <div class="flex gap-2 w-full">
            <div class=" left-input-field flex flex-col gap-2">
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">Encomenda Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="recolha_model.encomenda_id" placeholder="Encomenda Id">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="numero">Armazem Carga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="recolha_model.armazem_carga" placeholder="Armazem Carga">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Armazem Descarga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="recolha_model.armazem_descarga" placeholder="Armazem Descarga">
                </div>
               
               
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="recolha_model.data" placeholder="Data">
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Fatura Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="recolha_model.fatura_id" placeholder="Fatura Id">
                </div>

          
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="recolha_model.status" placeholder="Status">
                </div>

                <h3 class="text-[var(--titulo)]">Entrega</h3>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">Encomenda Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="entrega_model.encomenda_id" placeholder="Encomenda Id">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="numero">Armazem Carga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="entrega_model.armazem_carga" placeholder="Armazem Carga">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Armazem Descarga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="entrega_model.armazem_descarga" placeholder="Armazem Descarga">
                </div>
               
               
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="entrega_model.data" placeholder="Data">
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Fatura Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="entrega_model.fatura_id" placeholder="Fatura Id">
                </div>

          
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="entrega_model.status" placeholder="Status">
                </div>


            </div>

            <div class="right w-[40vw] flex flex-col gap-2 rounded-[10px] bg-[var(--fundoApp)] p-4 ">
                <h3 class="text-[var(--titulo)]">Item Recolha</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Recolha Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_recolha_model.recolha_id" placeholder="Recolha Id">

                    <label class="min-w-[6.5rem]" for="data">Encomenda Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_recolha_model.encomenda_id" placeholder="Encomenda Id">
                </div>

                <div class=" flex gap-2">

                    <label class="min-w-[6.5rem]" for="data">Produto Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_recolha_model.produto_id" placeholder="Produto Id">
                    
                    <label class="min-w-[6.5rem]" for="data">Quantidade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_recolha_model.quantidade" placeholder="Quantidade">
                    
                </div>
                <div class=" flex gap-2">

                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="item_recolha_model.status" placeholder="Status">

                  
                </div>

                <h3 class="text-[var(--titulo)]">Item Entrega</h3>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Entrega Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_entrega_model.entrega_id" placeholder="Recolha Id">

                    <label class="min-w-[6.5rem]" for="data">Encomenda Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_entrega_model.encomenda_id" placeholder="Encomenda Id">
                </div>

                <div class=" flex gap-2">

                    <label class="min-w-[6.5rem]" for="data">Produto Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_entrega_model.produto_id" placeholder="Produto Id">
                    
                    <label class="min-w-[6.5rem]" for="data">Quantidade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number"  v-model="item_entrega_model.quantidade" placeholder="Quantidade">
                    
                </div>
                <div class=" flex gap-2">

                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text"  v-model="item_entrega_model.status" placeholder="Status">

                </div>

                <AppTable :visibility="true" :show="true" :table_data="produtos" table_title="Produtos"
                  @row-clicked="select_produto" @close="close_table" :show_multiSelect="false" />
                
            </div>

        </div>
        

    </div>

</template>


<script>
    import axios from 'axios';
    import AppButton from '@/components/button.vue'
    import AppTable from '@/components/tables/table.vue'
    export default {
        name: 'encomenda',
        components: {
            AppButton,
            AppTable
        },
        props: {
          entities: {
              type: Array,
              default: () => [
                {
                    nome: '',
                    id: 0
                },
                {
                    id: 0,
                    numero: '',
                }
              ]
            },  
        },
        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                recolha_model: {
                   encomenda_id:0,
                   armazem_carga: '',
                   armazem_descarga: 0,
               
                   data: '',
                   
                   fatura_id: 0,
                  
                   status: '',
                },
                item_recolha_model:{
                    recolha_id: 0,
                    encomenda_id: 0,
                    produto_id:0,
                    quantidade: 0,
                    status: '',
                },
                entrega_model:{
                    encomenda_id:0,
                    armazem_carga: '',
                    armazem_descarga: 0,
                
                    data: '',
                    
                    fatura_id: 0,
                    
                    status: '',
                },

                item_entrega_model:{
                    entrega_id: 0,
                    encomenda_id: 0,
                    produto_id:0,
                    quantidade: 0,
                    status: '',
                },
                produtos:[],
              
                
            };
        },
        async created() {
            this.produtos= await this.select_all(`${this.baseURl}/api/v1/produto/`);

        
        },
        methods: {
            close() {
                this.$emit('close');
            },
            async create(data, url) {
              try {
                  const res = await axios.post(url, data);
                  return res.data.data;
              } catch (error) {
                  console.error('Error getting data:', error);
              }
            },
  
        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
    
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
    
            } catch (error) {
                console.error('Error getting data:', error);
            }
    
        },
    
        async update(url, data) {
    
            try {
                const res = await axios.put(url, data);
                console.log('Data successfully updated:', res.data);
                return res.data.data;
    
            } catch (error) {
                console.error('Error posting data:', error);
            }
        },
    
        async remove(url) {
            // console.log("Data:", data.id)
            try {
                await axios.delete(url);
                return true;
            } catch (error) {
                console.error('Error deleting data:', error);
            }
        },
            
        }
    }

</script>



<style scoped>


</style>